import { render, staticRenderFns } from "./allWarehouses.vue?vue&type=template&id=a351b3fe"
import script from "./allWarehouses.vue?vue&type=script&lang=js"
export * from "./allWarehouses.vue?vue&type=script&lang=js"
import style0 from "./allWarehouses.vue?vue&type=style&index=0&id=a351b3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports